/**
 * Calculate speed in MPH given track length and elapsed time.
 * @param trackLengthFt - Track length in feet
 * @param elapsedTimeMs - Elapsed time in milliseconds
 * @returns Speed in miles per hour, or null if inputs are invalid
 */
export function calculateMph(
	trackLengthFt: number | null | undefined,
	elapsedTimeMs: number | null | undefined,
): number | null {
	if (!trackLengthFt || !elapsedTimeMs || elapsedTimeMs <= 0) return null;
	const elapsedSeconds = elapsedTimeMs / 1000;
	const feetPerSecond = trackLengthFt / elapsedSeconds;
	const mph = feetPerSecond * (3600 / 5280);
	return mph;
}

/**
 * Format speed as a string with units.
 */
export function formatMph(mph: number | null): string {
	if (mph == null) return "";
	return `${mph.toFixed(1)} mph`;
}
